import { AxiosResponse } from 'axios';

import { api } from '../../http';
import {
  BaseFilter,
  ComplexRoleApiResponse,
  ComplexRoleUI,
  PageRequest,
  PageResponse,
} from '../../types/interfaces';

import { ApiResponse } from './interfaces';

export const ComplexRoleService = {
  getComplexRoles(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
    }
  ): Promise<AxiosResponse<ApiResponse<PageResponse<ComplexRoleUI>>>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.append(key, String(params[key]));
      }
    });

    return api.get<ApiResponse<PageResponse<ComplexRoleUI>>>('ComplexRole', {
      params: searchParams
    });
  },

  updateComplexRole(
    id: number, 
    ComplexRole: ComplexRoleUI
  ): Promise<AxiosResponse<ApiResponse<ComplexRoleUI>>> {
    return api.put<ApiResponse<ComplexRoleUI>>(
      `ComplexRole/${id}`,
      ComplexRole
    );
  },

  deleteComplexRole(id: number): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`ComplexRole/${id}`); 
  },

  createComplexRole(
    ComplexRole: ComplexRoleUI
  ): Promise<AxiosResponse<ApiResponse<ComplexRoleUI>>> {
    return api.post<ApiResponse<ComplexRoleUI>>('ComplexRole', ComplexRole);
  }, 
  getComplexRolesForSelection(): Promise<AxiosResponse<ComplexRoleApiResponse>> {
    return api.get<ComplexRoleApiResponse>('ComplexRole', {
      params: { ForSelection: 'true' }
    });
  }
};
